'use client';

import { ReactNode } from 'react';

import { Theme } from '../base-theme';
import { defaultTheme } from '../themes/default';

// Map of available themes
const themes: Record<string, Theme> = {
  default: defaultTheme,
};

export interface ThemeProviderProps {
  children: ReactNode;
  themeName?: keyof typeof themes;
}

export function ThemeProvider({
  children,
  themeName = 'default',
}: ThemeProviderProps) {
  // Get the requested theme
  const theme = themes[themeName] || themes.default;
  if (!theme) throw new Error(`Theme ${themeName} not found`);

  // Create CSS variables string
  const cssVars = Object.entries(theme.cssVars)
    .map(([key, value]) => `${key}: ${value};`)
    .join('\n');

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: `:root { ${cssVars} }` }} />
      <div data-theme={theme.name}>{children}</div>
    </>
  );
}
